import React, { useState } from 'react';
// import { formatRoute } from 'react-router-named-routes';
import Icon from '@mdi/react';
import { mdiPlusCircle } from '@mdi/js';
import { Box, useTheme } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
import NewMembershipTierModal from './new_membership_tier_modal';
// import { SMORG_STUDIO_MEMBERSHIP_TIER_ROUTE } from '../../services/routes';
import {
  useCreateMembershipTierMutation,
  useGetSpaceQuery,
} from '../../app/smorgAppSyncGraphQLApi';
import { healthProGroupForSpaceID } from '../../services/users';

const AddMembershipTierLink = () => {
  const theme = useTheme();

  // const navigate = useNavigate();

  const { data: healthProSpace } = useGetSpaceQuery();

  const [createMembershipTier] = useCreateMembershipTierMutation();

  const [newMembershipTierVisible, setNewMembershipTierVisible] =
    useState(false);

  const onNewMembershipTierCreated = async (membershipTierWithoutID) => {
    const currentHealthProGroup =
      healthProSpace && healthProGroupForSpaceID(healthProSpace.id);
    const input = {
      ...membershipTierWithoutID,
      groups: currentHealthProGroup && [currentHealthProGroup],
    };
    await createMembershipTier(input);
  };

  const handleCloseModal = () => {
    setNewMembershipTierVisible(false);
  };

  return (
    <>
      <Box display="flex" justifyContent="flex-end">
        <Icon
          path={mdiPlusCircle}
          style={{
            width: '32px',
            height: '32px',
            cursor: 'pointer',
            color: theme.palette.primary.dark,
            marginTop: 6,
            justifyContent: 'flex-end',
          }}
          onClick={() => {
            setNewMembershipTierVisible(true);
          }}
        />
      </Box>
      {newMembershipTierVisible && (
        <NewMembershipTierModal
          onNewMembershipTierCreated={onNewMembershipTierCreated}
          onDismiss={handleCloseModal}
        />
      )}
    </>
  );
};

export default AddMembershipTierLink;
